import axios from 'axios'

export default {
  namespaced: true,
  state: {
    commonPaymentTermGrid: [],
    commonPaymentTerm: [],
    pageData: null,
  },
  mutations: {
    setCommonPaymentTermGrid(state, payload) {
      state.commonPaymentTermGrid = payload
    },
    setCommonPaymentTerm(state, payload) {
      state.commonPaymentTerm = payload
    },
    setPageData(state, payload) {
      state.pageData = payload
    },
  },
  getters: {
    getCommonPaymentTerm: (state) => {
      return state.commonPaymentTerm
    },
    getCommonPaymentTermGrid: (state) => {
      return state.commonPaymentTermGrid
    },
    getPageData: (state) => {
      return state.pageData
    },
  },
  actions: {
    onCommonPaymentTermGrid({commit, rootState}, {limit, page, sort}) {
      commit('setLoadingAnimationFullPage', true, {root: true})
      let url =
        rootState.apiDomain + '/api/admin/common/payment-terms/grid?limit=' + limit + '&page=' + page +
        String(sort ? '&order[]=' + sort.param + ':' + sort.value : '&order[]=id:desc')
      return new Promise((resolve, reject) => {
        axios({url, method: 'GET'})
          .then((resp) => {
            commit('setCommonPaymentTermGrid', resp.data.data)
            commit('setPageData', resp.data)
            resolve(resp)
            commit('setLoadingAnimationFullPage', false, {root: true})
          })
          .catch((err) => {
            reject(err)
            commit('setLoadingAnimationFullPage', false, {root: true})
          })
      })
    },
    onCommonPaymentTermDelete({rootState}, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/common/payment-terms/' + id,
          id: id,
          method: 'DELETE',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onCommonPaymentTermUpdate({ rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/common/payment-terms/' + data.id,
          data: data,
          method: 'PUT',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onCommonPaymentTermCreate({ rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/common/payment-terms',
          data: data,
          method: 'POST',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
}
